<template>
  <div class="header">
    <div class="content">
      <div class="pez_logo">
        <a
          href="https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/index.html"
          title="PayEasy 全國最大企業福利網"
          target="_blank"
          ><img
            class="event_tracking"
            src="https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/images/logo_header.png"
            data-slot="LOGO"
            data-ga-title="PayEasy LOGO"
        /></a>
      </div>
      <ul class="navigation" @click="closeMask">
        <li class="event_tracking" slot="上方選單" data-ga-title="選單-首頁">
          <a
            href="https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/index.html "
            >首頁</a
          >
        </li>
        <li class="drop_menu">
          <div class="drop_btn" @click="dropBtn">關於我們</div>
          <ul class="drop_menu_container">
            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-公司介紹"
            >
              <a
                href="https://www.payeasy.com.tw/payeasy/event/request/about.shtml "
                >公司介紹</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-大事記"
            >
              <a
                href="https://www.payeasy.com.tw/payeasy/event/request/about.shtml#group_2 "
                >大事記</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-碳足跡認證"
            >
              <a
                href="https://www.payeasy.com.tw/payeasy/event/request/about.shtml#group_3 "
                >碳足跡認證</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-ESG360"
            >
              <a
                href="https://www.payeasy.com.tw/payeasy/event/request/about.shtml#group_4 "
                >ESG360</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-人才招募"
            >
              <a
                href="https://www.payeasy.com.tw/payeasy/event/request/about.shtml#group_7 "
                >人才招募</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-聯絡管道"
            >
              <a
                href="https://www.payeasy.com.tw/payeasy/event/request/about.shtml#group_9 "
                >聯絡管道</a
              >
            </li>
          </ul>
        </li>
        <li class="drop_menu">
          <div class="drop_btn" @click="dropBtn">產品服務</div>
          <ul class="drop_menu_container">
            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-企業福利網"
            >
              <a
                href="https://www.payeasy.com.tw/PWelfareWeb/COMMON/CorporateWebsite/index.html "
                >企業福利網</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-旅遊服務"
            >
              <a
                href="https://www.payeasy.com.tw/travel/event/invitation/index.html "
                >旅遊服務</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-禮贈平台"
            >
              <a href="https://www.payeasy.com.tw/static/beshop/#/invitation "
                >禮贈平台</a
              >
            </li>

            <li
              class="event_tracking"
              slot="上方選單"
              data-ga-title="選單-企業採購"
            >
              <a
                href="https://www.payeasy.com.tw/static/beshop/#/events/purchase "
                >企業採購</a
              >
            </li>
          </ul>
        </li>
        <li
          class="event_tracking Nav-slide"
          slot="上方選單"
          data-ga-title="選單-成功案例"
        >
          <a
            href="https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/case.html "
            >成功案例</a
          >
        </li>
        <li
          class="event_tracking"
          slot="上方選單"
          data-ga-title="選單-媒體報導"
        >
          <a
            href="https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/media.html "
            >媒體報導</a
          >
        </li>
        <li class="drop_menu activeAcc">
          <div class="btn_wh drop_btn" @click="dropBtn">用戶專區</div>
          <ul class="drop_menu_container">
            <li>
              <a
                class="event_tracking"
                slot="上方選單"
                data-ga-title="企業福利網登入"
                href="https://www.payeasy.com.tw/Cas/login?service=https%3A%2F%2Fwww.payeasy.com.tw%2F "
                >企業福利網 登入</a
              >
            </li>

            <li>
              <a
                class="event_tracking"
                slot="上方選單"
                data-ga-title="企業員工開通"
                href="https://www.payeasy.com.tw/PUBLICPcash/AuthLogin.do "
                >企業員工 開通</a
              >
            </li>

            <li>
              <a
                class="event_tracking"
                slot="上方選單"
                data-ga-title="禮贈平台登入"
                href="https://www.payeasy.com.tw/static/beshop/#/login "
                >禮贈平台 登入</a
              >
            </li>

            <li>
              <a
                class="event_tracking"
                slot="上方選單"
                data-ga-title="訪客會員註冊"
                href="https://member.payeasy.com.tw/mypage/Account/AddMember "
                >訪客會員 註冊</a
              >
            </li>
          </ul>
        </li>
        <li class="btn_nav">
          <a
            class="btn_orange event_tracking"
            slot="上方選單"
            data-ga-title="選單-福委免費諮詢"
            href="https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/consultform/index.html "
            >福委免費諮詢</a
          >
        </li>
      </ul>
      <div class="btn_nav_m null" @click="showMask"></div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "HeaderLayout",
  mounted() {
    document
      .querySelector(".header")
      .addEventListener("click", function (event) {
        if (event.target.dataset.slot) {
          window.dataLayer.push({
            event: "click_button",
            main_page: "PC application", // 主要頁面
            slot: event.target.dataset.slot, // 版位
            slot_detail: event.target.dataset.gaTitle, // 版位細項
          });
        }
      });
  },
  methods: {
    showMask() {
      $(".btn_nav_m").removeClass("null");
      $(".navigation,.btn_nav_m").addClass("active");
    },
    closeMask() {
      $(".navigation,.btn_nav_m").removeClass("active");
      $(".btn_nav_m").addClass("null");
    },
    dropBtn() {
      $(this).parent().find(".drop_menu_container").addClass("active");
      $(".mask").addClass("active");
    },
  },
};
</script>

<style>
.navigation {
  justify-content: flex-end !important;
}
@media (max-width: 992px) {
  .navigation {
    justify-content: flex-start !important;
  }
}
</style>
